import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const Hint = ({ children, ...props }) => {
    return (
        <div
            className="govuk-hint"
            {...props}
        >
            { children }
        </div>
    );
};

Hint.propTypes = {
    ...defaultAriaProps
};

export default Hint;
